import { extendObservable, computed, observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class PanelControlModel {
  @observable
  disabledMap = {
    ControlPanel: true,
    AnalysisPanel: false,
    OpacityPanel: true,
    MeasurementPanel: true,
    ExportPanel: false
  };

  get controlPanelDisable() {
    return this.disabledMap["ControlPanel"];
  }
  set controlPanelDisable(isDisabled) {
    this.disabledMap["ControlPanel"] = isDisabled;
  }

  get analysisPanelDisable() {
    return this.disabledMap["AnalysisPanel"];
  }
  set analysisPanelDisable(isDisabled) {
    this.disabledMap["AnalysisPanel"] = isDisabled;
  }

  get opacityPanelDisable() {
    return this.disabledMap["OpacityPanel"];
  }
  set opacityPanelDisable(isDisabled) {
    this.disabledMap["OpacityPanel"] = isDisabled;
  }

  get measurementPanelDisable() {
    return this.disabledMap["MeasurementPanel"];
  }
  set measurementPanelDisable(isDisabled) {
    this.disabledMap["MeasurementPanel"] = isDisabled;
  }

  get exportPanelDisable() {
    return this.disabledMap["ExportPanel"];
  }
  set exportPanelDisable(isDisabled) {
    this.disabledMap["ExportPanel"] = isDisabled;
  }
}

export default PanelControlModel;
